import { Routes } from "@angular/router";
import { LvfAppModule, LvfTrainingSessionParticipantRole } from "@kiraah-shared/common";
import {
  MOBILE_LEARNING_CAMPAIGN_SEQUENCE_LIST_CONFIG,
  MOBILE_ELEARNING_SEQUENCE_LIST_CONFIG,
} from "../elearning-player/helpers/mobile-elearning-sequence-list.config";
import {
  MOBILE_LEARNING_CAMPAIGN_LVF_MODULE,
  MOBILE_LEARNING_CAMPAIGN_PARTICIPANT_ROLE,
  MOBILE_LEARNING_CAMPAIGN_ROUTE_SEGMENTS,
  type MobileLearningCampaignRouteSegments,
} from "./mobile-learning-campaign-route.provider";

const learningCampaignListRoute: Routes[number] = {
  path: "",
  pathMatch: "full",
  providers: [{ provide: MOBILE_ELEARNING_SEQUENCE_LIST_CONFIG, useValue: MOBILE_LEARNING_CAMPAIGN_SEQUENCE_LIST_CONFIG }],
  loadComponent: () =>
    import("../elearning-player/mobile-elearning-sequence-list-page/mobile-elearning-sequence-list-page.component").then(
      (moduleExports) => moduleExports.MobileElearningSequenceListPageComponent
    ),
};

const learningCampaignChildRoutes: Routes = [
  learningCampaignListRoute,
  {
    path: ":campaignUid/player",
    loadComponent: () =>
      import("./mobile-learning-campaign-player-page/mobile-learning-campaign-player-page.component").then(
        (moduleExports) => moduleExports.MobileLearningCampaignPlayerPageComponent
      ),
  },
  {
    path: ":campaignUid",
    loadComponent: () =>
      import("./mobile-learning-campaign-player-page/mobile-learning-campaign-player-page.component").then(
        (moduleExports) => moduleExports.MobileLearningCampaignPlayerPageComponent
      ),
  },
];

function learningCampaignShellRoutes(
  segments: MobileLearningCampaignRouteSegments,
  participantRole: LvfTrainingSessionParticipantRole,
  permissionModule: LvfAppModule
): Routes {
  return [
    {
      path: "",
      providers: [
        { provide: MOBILE_LEARNING_CAMPAIGN_ROUTE_SEGMENTS, useValue: segments },
        { provide: MOBILE_LEARNING_CAMPAIGN_PARTICIPANT_ROLE, useValue: participantRole },
        { provide: MOBILE_LEARNING_CAMPAIGN_LVF_MODULE, useValue: permissionModule },
        { provide: MOBILE_ELEARNING_SEQUENCE_LIST_CONFIG, useValue: MOBILE_LEARNING_CAMPAIGN_SEQUENCE_LIST_CONFIG },
      ],
      children: learningCampaignChildRoutes,
    },
  ];
}

/** Apprenant → `/mobile/elearning/student/surveys` */
export const authenticatedStudentLearningCampaignRoutes = learningCampaignShellRoutes(
  ["student", "surveys"],
  LvfTrainingSessionParticipantRole.STUDENT,
  LvfAppModule.ELEARNING_STUDENT_SESSION
);

/** Formateur → `/mobile/elearning/mentor/surveys` */
export const authenticatedMentorLearningCampaignRoutes = learningCampaignShellRoutes(
  ["mentor", "surveys"],
  LvfTrainingSessionParticipantRole.MENTOR,
  LvfAppModule.ELEARNING_MENTOR_SESSION
);

/** Contact → `/mobile/elearning/contact/surveys` */
export const authenticatedContactLearningCampaignRoutes = learningCampaignShellRoutes(
  ["contact", "surveys"],
  LvfTrainingSessionParticipantRole.THIRD_PART_CONTACT,
  LvfAppModule.ELEARNING_THIRD_PART_CONTACT_SEQUENCE_PLAYER
);

/** Tuteur → `/mobile/elearning/supervisor/surveys` */
export const authenticatedSupervisorLearningCampaignRoutes = learningCampaignShellRoutes(
  ["supervisor", "surveys"],
  LvfTrainingSessionParticipantRole.SUPERVISOR,
  LvfAppModule.ELEARNING_SUPERVISOR_SEQUENCE_PLAYER
);
